// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"61219ee0","703":"e5f12e15","787":"1d7d5ed5"}[chunkId] + ".chunk.js";
};